import React from "react";
import cn from "classnames";
import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";
import styles from "./replace-blueprint-gradient-box-description-container.module.scss";
import { useI18N } from "@src/language/language-context";

interface ReplaceBlueprintGradientBoxDescriptionContainerPropTypes {
  isCurrentOrSelected: "current" | "selected";
  blueprint: BlueprintsArrayObjectTypes;
}

const cssClassName = "replace-blueprint-gradient-box-description-container";

export const ReplaceBlueprintGradientBoxDescriptionContainer = ({
  isCurrentOrSelected,
  blueprint,
}: ReplaceBlueprintGradientBoxDescriptionContainerPropTypes) => {
  const i18n = useI18N();

  const texts = {
    descriptionTitle: i18n(
      "modules.replaceBlueprintGradientBoxDescriptionContainer.descriptionTitle",
    ),
  };

  return (
    <div className={styles[cssClassName]}>
      <p
        className={cn(styles[`${cssClassName}__blueprint-info-text`], {
          [styles[`${cssClassName}__blueprint-info-text--gray`]]:
            isCurrentOrSelected === "current",
        })}
      >
        {texts.descriptionTitle}
      </p>
      <p
        className={cn(
          styles[`${cssClassName}__blueprint-info-text`],
          styles[`${cssClassName}__blueprint-info-text--gray`],
        )}
      >
        {blueprint.description}
      </p>
    </div>
  );
};
